module.exports = __webpack_public_path__ + "img/companyewm.169daef9.png";